import { render, staticRenderFns } from "./TabView.vue?vue&type=template&id=e370ba38&scoped=true&"
import script from "./TabView.vue?vue&type=script&lang=js&"
export * from "./TabView.vue?vue&type=script&lang=js&"
import style0 from "./TabView.vue?vue&type=style&index=0&id=e370ba38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e370ba38",
  null
  
)

export default component.exports